import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { TextField as MuiTextField, type TextFieldProps } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { type TOverride } from '@/types/common';
import { type TTranslateKey } from '@/types/i18n';

const useStyles = makeStyles((theme) => ({
  input: {
    [theme.breakpoints.down('mobile')]: {
      fontSize: '16px',
    },
  },
}));

export type TTextFieldProps = TOverride<
  TextFieldProps,
  { label?: TTranslateKey; placeholder?: TTranslateKey }
>;

const TextField = ({
  label,
  placeholder,
  onChange,
  value,
  InputProps,
  ...props
}: TTextFieldProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const inputProps = {
    classes: {
      input: classes.input,
    },
    ...InputProps,
  };

  return (
    <MuiTextField
      fullWidth
      label={label ? t(label) : ''}
      placeholder={placeholder ? t(placeholder) : ''}
      value={value}
      variant="outlined"
      onChange={onChange}
      InputProps={inputProps}
      {...props}
      data-testid={label}
    />
  );
};

const Memoized = memo(TextField) as typeof TextField;

export { Memoized as TextField };
